import { clamp } from "lodash"

export const AREA_RATIO = 0.3
export const ARROW_LEFT = 37
export const ARROW_RIGHT = 39

export const getNewIndex = (
  index: number,
  diff: number,
  pageLength: number,
) => {
  return clamp(index + diff, 0, pageLength - 1)
}

export const isNextPageNavigationArea = (percent: number) =>
  percent <= AREA_RATIO

export const isPrevPageNavigationArea = (percent: number) =>
  percent >= 1 - AREA_RATIO

export const isPageNavigationArea = (
  percent: number,
  isFirstPage: boolean,
  isLastPage: boolean,
) => {
  // 最初のページ
  if (isFirstPage && isNextPageNavigationArea(percent)) {
    return true
  }

  // 最後のページ
  if (isLastPage && isPrevPageNavigationArea(percent)) {
    return true
  }

  // 途中のページ
  if (
    !isFirstPage &&
    !isLastPage &&
    (isNextPageNavigationArea(percent) || isPrevPageNavigationArea(percent))
  ) {
    return true
  }

  return false
}
